import Subscription from '@/domain/models/Subscription';

export default class PlanCard {
  $id: string;

  $name: string;

  $description: string;

  $subscriptions: Subscription[];

  $screenTitle: string;

  constructor(
    id: string,
    name: string,
    description: string,
    subscriptions: Subscription[],
    screenTitle = '',
  ) {
    this.$id = id;
    this.$name = name;
    this.$description = description;
    this.$subscriptions = subscriptions;
    this.$screenTitle = screenTitle;
  }

  get id(): string {
    return this.$id;
  }

  get name(): string {
    return this.$name;
  }

  get description(): string {
    return this.$description;
  }

  get subscriptions(): Subscription[] {
    return this.$subscriptions;
  }

  get screenTitle(): string {
    return this.$screenTitle;
  }

  get mainSubscription(): Subscription {
    const i = Math.floor(this.subscriptions.length / 2);
    return this.subscriptions[i];
  }
}
